export const GRID_ESPOT_2_MIN_TILES = 8;
export const GRID_ESPOT_3_MIN_TILES = 12;
export const GRID_ESPOT_2_MIN_TILES_LG = 6;
export const CATEGORIES_SIZE = 30;

export const CATEGORIES_PAGE_ESPOT_2 = 'CATSAS_SHOP_BY_CATEGORY_ESPOT_2';
export const CATEGORIES_PAGE_ESPOT_3 = 'CATSAS_SHOP_BY_CATEGORY_ESPOT_3';
export const CATEGORIES_PAGE_ESPOT_4 = 'CATSAS_SHOP_BY_CATEGORY_ESPOT_4';
